import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/logo-white.png";

class Page404 extends React.Component {
  render() {
    return (
      <div className="theme-cyan">
        <div >
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main">
              <div className="auth-box">
                <div className="top">
                  <img src={Logo} alt="Serviszone" style={{ width: "150px", margin: "10px" }} />
                </div>
                <div className="card">
                  <div className="header">
                    <h3 >
                      <span className="clearfix title">
                        <span className="number left"></span>
                        <span className="text">Oops! <br />Sayfa Bulunamadı</span>
                      </span>
                    </h3>
                  </div>
                  <div className="body">
                    <p>Erişmeye çalıştığınız sayfa bulunamadı, Lütfen <Link to="/ticket-add">bize bildirin</Link></p>
                    <div className="margin-top-30">
                      <Link to="#" className="btn btn-default" onClick={() => {
                        this.props.history.push("dashboard")
                      }}><a className="btn btn-outline-primary" href="#!"><i className="fa fa-home"></i>&nbsp;
                        <span>Anasayfa</span></a></Link>&nbsp;
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Page404.propTypes = {
};

const mapStateToProps = ({ loginReducer }) => ({
});

export default connect(mapStateToProps, {
})(Page404);
